export const tooltipTemplate = (
  stylecontext: string,
  node: HTMLElement,
) => `<one-popover cloak context="${stylecontext}" placement="bottom">
<one-link as="span" color="prominent" strong>${node.innerText}</one-link>
<div slot="content">
  ${node.title}
</div>
</one-popover>`;

export default tooltipTemplate;
